import { cardBlogProjection } from '../components/Molecules/CardBlog.query';

export const pageResourceCenterIndex = groq`*[_type == "resourceCenterIndexPage" && currentPathname == $currentPathname][0]{
  ...,
  _id,
  _type,
  currentPathname,
  title,
  description,
  goToPage,
  showResults,
  filterTopicsBy,
  clearAll,
  featuredAsset {
    reference-> {
      ${cardBlogProjection}
    }
  },
  heroImage,
  "filters": showFilter[]->{
    _id,
    "slug": slug.current
  }
}`;
